<template>
  <v-dialog width="700px" persistent :value="show" @input="$emit('change', $event)">
    <v-card height="280px">
      <v-card-text class="h-100">
        <v-layout column class="h-100">
          <v-flex>
            <v-layout column>
              <v-flex md1 class="text-xs-center" mb-4>
                <span class="title pa-0">
                  Variables
                </span>
              </v-flex>
              <v-flex>
                <v-layout text-xs-center
                  row wrap>
                  <v-flex md4 
                    v-for="(item, i) in vars" 
                    :key="`variable-${i}`" >
                    <v-checkbox
                      :label="item.text"
                      :false-value="0"
                      :true-value="1"
                      v-model="item.active">
                    </v-checkbox>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex>
            <v-layout class="h-100" justify-end align-end>
              <span class="red--text accent-3" v-if="!checkVar">
                Debe haber al menos una variable seleccionada
              </span>
              <v-btn flat @click="$emit('change', false)">Cerrar</v-btn>
              <v-btn flat class="k-orange-linear-text" @click="save()">Guardar</v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
  components: {
    VuePerfectScrollbar,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    filters: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      vars: [
        {
          text: 'Genero',
          column: 'gender',
          active: true,
        },
        {
          text: 'Grupo de edad',
          column: 'age_group',
          active: true,
        },
        {
          text: 'Estado marital',
          column: 'marital_status',
          active: true,
        },
        {
          text: 'Primera día de mora',
          column: 'first_delinquency',
          active: true,
        },
        {
          text: 'Tipo de cartera',
          column: 'portfolio_type',
          active: true,
        },
        {
          text: 'Producto',
          column: 'account_type',
          active: true,
        },
        {
          text: 'Moneda',
          column: 'currency',
          active: true,
        },
        {
          text: 'Estado',
          column: 'state',
          active: true,
        },
        {
          text: 'Día de vencimiento',
          column: 'due_day',
          active: true,
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      'dimentions',
    ]),
    checkVar() {
      return _.filter(this.vars, 'active').length;
    },
  },
  mounted() {
    this.getVars();
  },
  methods: {
    getVars() {
      this.axios.get('segmentation/vars')
        .then(({ data }) => {
          let activeAll = false;
          if (!data.length) {
            activeAll = true;
          }
          if (!activeAll) {
            for (let i = 0; i < data.length; i += 1) {
              const dimension = this.vars.find(x => x.column === data[i].dimension);
              if (dimension) {
                dimension.active = data[i].status;
              }
            }
          } else {
            for (let i = 0; i < this.vars.length; i += 1) {
              this.vars[i].active = true;
            }
          }
        });
    },
    save() {
      if (this.checkVar) {
        this.$store.commit('SET_DOWNLOAD_CHANNEL', `company.${this.$auth.user().company.id}.${this.$auth.user().id}.download_report`);
        this.$store.dispatch('SEND_DOWNLOAD_REQUEST', {
          route: 'segmentation/vars',
          params: {
            functionName: 'load_segments',
            vars: this.vars,
            filters: this.filters,
          },
        }).catch(({ response }) => {
          if (response.status === 418) {
            this.$emit('show-error');
          }
        });
      }
    },
  },
  watch: {
    dimentions: {
      deep: true,
      handler(val) {
        for (let i = 0; i < val.length; i += 1) {
          this.vars.push({
            text: val[i].title,
            column: val[i].name,
            active: false,
          });
        }
        this.getVars();
      },
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/reports/segmentation/VariablesModal.vue